import { faFileImage } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { stylesheet } from 'typestyle';

const css = stylesheet({
  noImage: {
    alignItems: 'center',
    backgroundColor: '#eeeeee',
    borderRadius: 'inherit',
    color: '#bbbbbb',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
  },
  squareThumbnailContainer: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    border: '1px solid #CCCCCC',
    borderRadius: '4px',
    height: '60px',
    width: '60px',
  },
  thumbnailContainer: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    border: '1px solid #CCCCCC',
    borderRadius: '4px',
    height: '60px',
    width: '100px',
  },
});

type ThumbnailProps = {
  thumbnailUrl?: string | null;
  square?: boolean;
  noPreviewRequired?: boolean;
};

export function Thumbnail({ thumbnailUrl, square, noPreviewRequired }: ThumbnailProps) {
  const container = square ? css.squareThumbnailContainer : css.thumbnailContainer;
  if (noPreviewRequired) {
    return <img className={container} data-cy="no-preview-thumbnail" src="/gdp-list-view/no-preview-thumbnail.jpg"></img>;
  }
  if (thumbnailUrl) {
    return (
      <div
        className={container}
        role="img"
        style={{
          backgroundImage: `url(${thumbnailUrl})`,
        }}
      ></div>
    );
  }
  return (
    <div className={container}>
      <div className={css.noImage}>
        <FontAwesomeIcon aria-label="missing thumbnail icon" icon={faFileImage} title="file-icon" />
      </div>
    </div>
  );
}
